angular.module('autoremind.templates')
    .directive('templateHighlight', ['templateService', '$timeout', '$animate',
    function (templateService, $timeout, $animate) {
        return {
            restrict: 'A',
            scope: {
                templateId: '=templateHighlight',
                scrolableId: '=',
                currentTemplate: '=',
                clonnedTemplate: '='
            },
            link: function (scope, element, attrs) {
                scope.templateService = templateService;
                scope.isPressed = false;
                var scrollElement = angular.element('#' + scope.scrolableId);
                var firstElementOfList = angular.element(angular.element('#' + scope.scrolableId).find('tr')[0]).offset().top;
                element.on('click', function () {
                    scope.isPressed = true;
                });
                //templateService.model.currentTemplate
                scope.$watch('currentTemplate', function (newVal, oldVal) {
                    if (!newVal || !angular.isDefined(newVal.templateId) || newVal.templateId !== scope.templateId) {
                        $animate.removeClass(element, 'templateSelected');
                        scope.isPressed = false;
                        return;
                    }
                    element.addClass('templateSelected');
                    if (!oldVal || newVal.templateId !== oldVal.templateId) {
                        scope.scrollToThisElement();
                    }
                });
                //templateService.clonedTemplateModel
                scope.$watch('clonnedTemplate', function (newVal, oldVal) {
                    if (newVal && angular.isDefined(newVal.templateId) && newVal.templateId === scope.templateId) {
                        element.addClass('templateCloned');
                        scope.scrollToThisElement();
                    }
                    else {
                        element.removeClass('templateCloned');
                        return;
                    }
                    $timeout(function () {
                        element.removeClass('templateCloned');
                    }, 10000);
                });
                scope.scrollToThisElement = function () {
                    if (scope.isPressed || !scrollElement) {
                        return;
                    }
                    scrollElement.animate({
                        scrollTop: scrollElement.scrollTop() + (element.offset().top - scrollElement.offset().top)
                    }, "slow");
                };
            }
        };
    }]);
//# sourceMappingURL=template-highlight.directive.js.map